import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Box, FormHelperText } from '@mui/material';

/**
 * Phone input field component with country code selector
 * Wraps react-phone-input-2 to match the application styling
 */
const PhoneInputField = ({
    value,
    onChange,
    error = '',
    label = 'Phone Number',
    country = 'sg',
    inputStyle = {},
    containerStyle = {},
    buttonStyle = {},
    dropdownStyle = {},
    inputProps = {},
    disabled = false,
    enableSearch = true,
    disableSearchIcon = false,
    autoFormat = true,
    preferredCountries = ['sg', 'us', 'gb', 'au', 'in'],
    placeholder = 'Enter phone number',
}) => {
    // Handle change and normalize the format
    const handleChange = (value) => {
        if (onChange) {
            onChange(value);
        }
    };

    // Calculate if there's an error to display
    const hasError = Boolean(error);

    return (
        <Box sx={{ width: '100%', ...containerStyle }}>
            {/* Label is handled by the parent component in our case */}
            <PhoneInput
                country={country}
                value={value}
                onChange={handleChange}
                enableSearch={enableSearch}
                disableSearchIcon={disableSearchIcon}
                autoFormat={autoFormat}
                disabled={disabled}
                preferredCountries={preferredCountries}
                placeholder={placeholder}
                countryCodeEditable={false}
                inputProps={{
                    name: 'phone',
                    ...inputProps,
                }}
                inputStyle={{
                    width: '100%',
                    height: '45px',
                    fontSize: '16px',
                    paddingLeft: '48px',
                    borderRadius: '4px',
                    borderColor: hasError ? '#f44336' : '#e0e0e0',
                    ...inputStyle
                }}
                buttonStyle={{
                    borderColor: hasError ? '#f44336' : '#e0e0e0',
                    ...buttonStyle
                }}
                dropdownStyle={{
                    width: '300px',
                    ...dropdownStyle
                }}
                searchStyle={{
                    width: '100%',
                    margin: '0',
                    padding: '10px'
                }}
                searchPlaceholder="Search countries"
            />

            {/* Error message display */}
            {hasError && (
                <FormHelperText
                    error
                    sx={{
                        marginLeft: '0',
                        fontWeight: 'medium',
                        marginTop: '8px',
                        fontSize: '0.85rem'
                    }}
                >
                    {error}
                </FormHelperText>
            )}
        </Box>
    );
};

PhoneInputField.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    label: PropTypes.string,
    country: PropTypes.string,
    inputStyle: PropTypes.object,
    containerStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
    dropdownStyle: PropTypes.object,
    inputProps: PropTypes.object,
    disabled: PropTypes.bool,
    enableSearch: PropTypes.bool,
    disableSearchIcon: PropTypes.bool,
    autoFormat: PropTypes.bool,
    preferredCountries: PropTypes.array,
    placeholder: PropTypes.string,
};

export default PhoneInputField;